import React from "react";
import "./NoteEditor.css";

import FinishNoteEdit from "./FinishEditedNote/FinishNoteEdit";
import DiscardNoteEdit from "./DiscardEditedNote/DiscardNoteEdit";
import { noteTemplate } from "../Templates/noteTemplate";

interface noteEditorProps {
    noteEditStatus: string, 
    finishNoteEditCallback: () => void, 
    discardNoteEditCallback: () => void, 
    noteData: noteTemplate | undefined
}

function NoteEditor(props: noteEditorProps): JSX.Element {
    let noteEditorCreatorClassName: string;

    props.noteEditStatus === "OpeningNoteEditor" ? noteEditorCreatorClassName = "openingNoteEditor" : 
    props.noteEditStatus === "ClosingNoteEditor" ? noteEditorCreatorClassName = "closingNoteEditor" : noteEditorCreatorClassName = "neutralNoteEditor";
    
    return (
        <section className={noteEditorCreatorClassName}>
            <div className="noteTitle">
                <input id="noteTitleInput" type="text" className="noteTitleInput" placeholder="Title.."/>
            </div>

            <div className="noteText">
                <textarea id="noteTextInput" className="noteTextInput" placeholder="Note.."></textarea>
            </div>

            <div className="buttons">
                <FinishNoteEdit callback={props.finishNoteEditCallback}/>
                <DiscardNoteEdit callback={props.discardNoteEditCallback}/>
            </div>
        </section>  
    )   
}

export default NoteEditor;
